import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import fullStar from '/public/dashboard/fullStar.svg';
import halfStar from '/public/dashboard/halfStar.svg';
import emptyStar from '/public/dashboard/emptyStar.svg';

const StarRating = ({ name, className, value = 0, editing = false, change, editReviewStarSize = 13 }) => {
  const [rating, setRating] = useState(value);

  useEffect(() => {
    setRating(value);
  }, [value]);

  const handleClick = (index, e) => {
    if (!editing) return;
    const star = e.currentTarget;
    const { left, width } = star.getBoundingClientRect();
    const clickX = e.clientX - left;
    let newRating = index;
    if (clickX < width / 2) {
      newRating = index - 0.5;
    }
    setRating(newRating);
    change(newRating);
  };

  const renderStars = () => {
    const stars = [];


    for (let i = 1; i <= 5; i++) {
      let starIcon = emptyStar;
      let isEmpty = "";
      if (rating >= i) {
        starIcon = fullStar;
        isEmpty = "";
      } else if (rating >= i - 0.5) {
        starIcon = halfStar;
        isEmpty = "isHalfEmptyStarIcon"
      }

      stars.push(
        <span key={i} onClick={(e) => handleClick(i, e)} style={{ cursor: editing ? 'pointer' : 'default', display: 'inline-block' }} className={isEmpty}>
          <img src={starIcon} alt={`star-${i}`} width={editReviewStarSize} height={editReviewStarSize - 1} />
        </span>
      );
    }
    return stars;
  };

  return (
    <div className={className} data-name={name}>
      {renderStars()}
    </div>
  );
};

StarRating.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.number,
  editing: PropTypes.bool,
  change: PropTypes.func,
  editReviewStarSize: PropTypes.number,
};

export default StarRating;